import queryString from "query-string";

export default function pageFromLocation(location) {
  const pageParam = queryString.parse(location.search).page;
  return pageParam > 0 ? parseInt(pageParam) : 1;
}
